export default "__VITE_ASSET__C98c5Ww5__"